<template>
    <div>
        <div v-if="loadIdeas || loadVote" class="vld-parent">
            <Loading :active.sync="loadIdeas" :is-full-page="fullPage" :height="128" :color="color"></Loading>
        </div>
        <div v-if="!loadIdeas && !loadVote" id="project-ideas-container"
            :data-intro="$t('proyecto.ruta_guiada.pasos.paso_4')" data-step="4" data-position="right"
            data-scrollTo="tooltip">
            <div v-if="ideas.length > 0">
                <div class="col-12 my-20">
                    <h4 class="ml-auto text-right">{{ $t('proyecto.contenido.question') }} {{ ideas.length > 0 ? questcount :
                        0 }} {{ $t('componentes.comentarios.info_text.de') }} {{ ideas.length }} </h4>
                </div>
                <carousel :per-page="1" :pagination-enabled="false" :mouse-drag="true" :touch-drag="true"
                    v-on:page-change="onPageChange" v-on:navigation-click="navigationHandler" :navigation-enabled="true"
                    navigation-prev-label="<div class='btn bg-indigo-dark-2 text-white font-18'><span><i class='fas fa-angle-left'></i></span></div>"
                    navigation-next-label="<div class='btn bg-indigo-dark-2 text-white font-18'><span><i class='fas fa-angle-right'></i></span><div>"
                    :paginationColor="'#A8A8A8'">

                    <slide v-for="idea in ideas" :key="idea.id" class="p-2 p-lg-5">

                        <div class="shadow p-3 mb-5 rounded-lg my-25 border p-3"
                            :style="mode === 'dark' ? 'background: rgb(12, 1, 80);' : ''">
                            <h5 :style="mode === 'dark' ? 'color: #fff' : ''" class="mb-10">{{ idea.title }}</h5>
                            <p class="text-justify" v-html="idea.detail"></p>
                            <div class="row no-gutters d-flex justify-content-center" style="margin-bottom: 20px;">
                                <div class="col-12">
                                    <br />
                                    <div class="option-container d-flex d-flex justify-content-center text-center ma-5">
                                        <template v-for="alternativa in JSON.parse(idea.alternatives).alternativas">
                                            <div class="alternativa card mx-md-10 pa-5 my-2 agree d-flex flex-column justify-content-between"
                                                v-bind:class="{
                                                    'agree-blocked': !isAvailableVoting,
                                                    'active_public_consultation': isAvailableVoting,
                                                    'consulta-selected': (idea.userVoted ? idea.userVoted[alternativa.id] : false) || LocalVote[ideas.indexOf(idea)].voteValue[alternativa.id],
                                                    'cant-select': idea.userVoted.find(vote => vote === true)
                                                }" style="display: inline-block;"
                                                @click="addLocalVote(alternativa.id, idea)"
                                                :style="mode === 'dark' ? 'background: rgb(12, 1, 80); border-color: #fff;' : ''">
                                                <span class="d-block">{{ alternativa.descripcion }}</span>
                                                <div>
                                                    <span :class="'col-6 font-30 ' + alternativa.color"><i
                                                            :class="alternativa.icono"></i></span>
                                                    <span
                                                        v-if="idea.userVoted.find(vote => vote === true) && alternativa.id == 0 || alternativa.id == 0 && !isAvailableVoting"
                                                        class="col-6 display-6">{{ idea.votes_0 }}</span>
                                                    <span
                                                        v-if="idea.userVoted.find(vote => vote === true) && alternativa.id == 1 || alternativa.id == 1 && !isAvailableVoting"
                                                        class="col-6 display-6">{{ idea.votes_1 }}</span>
                                                    <span
                                                        v-if="idea.userVoted.find(vote => vote === true) && alternativa.id == 2 || alternativa.id == 2 && !isAvailableVoting"
                                                        class="col-6 display-6">{{ idea.votes_2 }}</span>
                                                    <span
                                                        v-if="idea.userVoted.find(vote => vote === true) && alternativa.id == 3 || alternativa.id == 3 && !isAvailableVoting"
                                                        class="col-6 display-6">{{ idea.votes_3 }}</span>
                                                    <span
                                                        v-if="idea.userVoted.find(vote => vote === true) && alternativa.id == 4 || alternativa.id == 4 && !isAvailableVoting"
                                                        class="col-6 display-6">{{ idea.votes_4 }}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <button v-if="!idea.userVoted.find(vote => vote === true) && isAvailableVoting"
                                    @click="addOrEditVote(idea)" class="mt-30 mx-md-15 btn-text btn btn-sm btn-success"
                                    v-tooltip.top="'Después de enviar la votación no puedes cambiar tu respuesta'">Enviar
                                    voto</button>
                            </div>
                            <IdeaComments v-if="idea.id && idea.enable_comment" :publicConsultation="project"
                                :idea_id="idea.id"></IdeaComments>
                        </div>

                    </slide>

                </carousel>

                <div class="mb-20" v-if="totalResults > ideas.length">
                    <button class="vld-parent btn btn-secondary btn-block" @click="loadMore">{{
                        $t('proyecto.contenido.cargar') }}
                        <loading :active.sync="loadBtnLoadMore" :is-full-page="fullPage" :height="24" :color="color">
                        </loading>
                    </button>
                </div>
            </div>
            <div v-else class="row no-gutters">
                <div class="col-12">
                    <div class="card border-success shadow ma-5" :class="mode === 'dark' ? 'dark' : 'light'">
                        <div class="card-body">
                            <p class="card-text">{{ $t('proyecto.contenido.sin_ideas') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="ideas.length > 0">
                <div class="col-12 my-20">
                    <h4 class="ml-auto text-right">{{ $t('proyecto.contenido.question') }} {{ ideas.length > 0 ? questcount :
                        0 }} {{ $t('componentes.comentarios.info_text.de') }} {{ ideas.length }} </h4>
                </div>
                <carousel :per-page="1" :pagination-enabled="false" :mouse-drag="true" :touch-drag="true"
                    v-on:page-change="onPageChange" v-on:navigation-click="navigationHandler" :navigation-enabled="true"
                    navigation-prev-label="<div class='btn bg-indigo-dark-2 text-white font-18'><span><i class='fas fa-angle-left'></i></span></div>"
                    navigation-next-label="<div class='btn bg-indigo-dark-2 text-white font-18'><span><i class='fas fa-angle-right'></i></span><div>"
                    :paginationColor="'#A8A8A8'">

                    <slide v-for="idea in ideas" :key="idea.id" class="p-2 p-lg-5">

                        <div class="shadow p-3 mb-5 rounded-lg my-25 border p-3"
                            :style="mode === 'dark' ? 'background: rgb(12, 1, 80);' : ''">
                            <h5 :style="mode === 'dark' ? 'color: #fff' : ''" class="mb-10">{{ idea.title }}</h5>
                            <p class="text-justify" v-html="idea.detail"></p>
                            <div class="row no-gutters d-flex justify-content-center" style="margin-bottom: 20px;">
                                <div class="col-12">
                                    <br />
                                    <div class="option-container d-flex d-flex justify-content-center text-center ma-5">
                                        <template v-for="alternativa in JSON.parse(idea.alternatives).alternativas">
                                            <div class="alternativa card mx-md-10 pa-5 my-2 agree d-flex flex-column justify-content-between"
                                                v-bind:class="{
                                                    'agree-blocked': !isAvailableVoting,
                                                    'cant-select': idea.userVoted
                                                }" style="display: inline-block;"
                                                @click="addLocalVote(alternativa.id, idea)"
                                                :style="mode === 'dark' ? 'background: rgb(12, 1, 80); border-color: #fff;' : ''">
                                                <span class="d-block">{{ alternativa.descripcion }}</span>
                                                <div>
                                                    <span :class="'col-6 font-30 ' + alternativa.color"><i
                                                            :class="alternativa.icono"></i></span>
                                                    <span v-if="alternativa.id == 0" class="col-6 display-6">{{ idea.votes_0
                                                    }}</span>
                                                    <span v-if="alternativa.id == 1" class="col-6 display-6">{{ idea.votes_1
                                                    }}</span>
                                                    <span v-if="alternativa.id == 2" class="col-6 display-6">{{ idea.votes_2
                                                    }}</span>
                                                    <span v-if="alternativa.id == 3" class="col-6 display-6">{{ idea.votes_3
                                                    }}</span>
                                                    <span v-if="alternativa.id == 4" class="col-6 display-6">{{ idea.votes_4
                                                    }}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <!-- <button v-if="!idea.userVoted.find(vote => vote === true) && isAvailableVoting" @click="addOrEditVote(idea)" class="mt-30 mx-md-15 btn-text btn btn-sm btn-success" v-tooltip.top="'Después de enviar la votación no puedes cambiar tu respuesta'" >Enviar voto</button> -->
                            </div>
                            <IdeaComments v-if="idea.id && idea.enable_comment" :publicConsultation="project"
                                :idea_id="idea.id"></IdeaComments>
                        </div>

                    </slide>

                </carousel>

                <div class="mb-20" v-if="totalResults > ideas.length">
                    <button class="vld-parent btn btn-secondary btn-block" @click="loadMore">{{
                        $t('proyecto.contenido.cargar') }}
                        <loading :active.sync="loadBtnLoadMore" :is-full-page="fullPage" :height="24" :color="color">
                        </loading>
                    </button>
                </div>
            </div>
            <div v-else class="row no-gutters">
                <div class="col-12">
                    <div class="card border-success shadow ma-5" :class="mode === 'dark' ? 'dark' : 'light'">
                        <div class="card-body">
                            <p class="card-text">{{ $t('proyecto.contenido.sin_ideas') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import IdeaComments from '../../views/Comments';
import PieChart from '../../PieChart.js';
import axios from '../../backend/axios';
import Loading from 'vue-loading-overlay';

export default {
    name: 'ProjectIdeas',
    components: {
        IdeaComments,
        PieChart,
        Loading
    },
    props: {
        project: Object,
        id: Number
    },
    data() {
        return {
            ideas: [],
            questcount: 1,
            totalResults: 0,
            limit: 40,
            offset: 0,
            currentMoment: this.$moment().local(),
            votingStartDate: this.$moment.utc(this.project.fecha_inicio, 'YYYY-MM-DD HH:mm:ss').local(),
            votingEndDate: this.$moment.utc(this.project.fecha_termino, 'YYYY-MM-DD HH:mm:ss').local(),
            isAvailableVoting: false,
            LocalVote: [],
            votes: [],
            chartsData: [],
            loadIdeas: true,
            loadVote: true,
            loadBtnLoadMore: false,
            fullPage: false,
            color: '#000000',
            mode: String,
            keyChartComponent: 0,
        };
    },
    mounted() {
        if ((this.$store.getters.modo_oscuro === 'dark') || (window.location.href.includes('dark'))) {
            this.mode = 'dark';
        } else {
            this.mode = 'light';
        }

        this.setIsAvailableVoting();
        this.getIdeas();
    },
    updated() {
        if (this.LocalVote.length != this.ideas.length) {
            for (let i = 0; i < this.ideas.length; i++) {
                this.LocalVote.push({
                    id: undefined,
                    voteValue: [false, false, false, false, false]
                })
            }
        }
    },
    methods: {
        prueba(idea, ideas) {
            return ideas.indexOf(idea)
        },
        onPageChange(currentPage) {
            this.questcount = currentPage + 1;
        },
        navigationHandler(direction) {
            if (direction === "forward" && this.questcount < this.ideas.length) {
                this.questcount++;
            }
            if (direction === "backward" && this.questcount > 1) {
                this.questcount--;
            }
        },
        setIsAvailableVoting() {
            if (this.$store.getters.userData && this.$store.getters.userData.rol === 'ADMIN') {
                this.isAvailableVoting = this.currentMoment.isBetween(this.votingStartDate, this.votingEndDate);
            } else {
                this.isAvailableVoting = this.project.estado === 1 && this.currentMoment.isBetween(this.votingStartDate, this.votingEndDate);
            }
        },
        getIdeas() {
            axios
                .get('/consultations/' + this.id + '/ideas', {
                    params: {
                        limit: this.limit,
                        offset: this.offset
                    }
                })
                .then(res => {

                    this.ideas = this.ideas.concat(res.data.results);
                    this.totalResults = res.data.total_results;
                    this.offset += res.data.returned_results;

                    if (this.$store.getters.isLoggedIn) {
                        this.getUserVotes();
                    }
                    this.loadVote = true
                })
                .finally(() => {
                    this.loadIdeas = false;
                });
        },
        getUserVotes() {
            let userId = this.$store.getters.userData.id;
            axios
                .get('/votes', {
                    params: {
                        user_id: userId,
                        return_all: 1
                    }
                })
                .then(res => {
                    let v = res.data.results;
                    this.ideas.forEach(idea => {
                        idea['userVoted'] = [false, false, false, false, false,]
                        v.forEach(vote => {
                            if (vote.public_consultation_idea_id == idea.id) {
                                this.votes.push(vote);
                                if (vote.vote === 0) {
                                    idea.userVoted[0] = true;
                                } else if (vote.vote === 1) {
                                    idea.userVoted[1] = true;
                                } else if (vote.vote === 2) {
                                    idea.userVoted[2] = true;
                                } else if (vote.vote === 3) {
                                    idea.userVoted[3] = true;
                                } else if (vote.vote === 4) {
                                    idea.userVoted[4] = true;
                                }
                            }
                        });
                        this.loadVote = false;
                    });
                });
        },
        loadMore() {
            this.loadBtnLoadMore = true;
            this.getIdeas();
        },
        /**
         * Cambia el valor de el voto de la idea y lo guarda en el array de objetos LocalVote
         * @param {number} voteValue Devuelve el indice del voto,
         * @param {object} ideaValue Objeto de la idea
         */
        addLocalVote(voteValue, ideaValue) {
            // let alredyVoted = this.LocalVote.find(idea => idea.id === ideaValue.id);
            let indice = this.ideas.indexOf(ideaValue)
            let alredyVoted = this.LocalVote[indice].voteValue[voteValue] === true;
            // console.log(idea);
            // console.log(alredyVoted);
            // console.log(indice);

            if (alredyVoted) {
                this.LocalVote[indice].voteValue[voteValue] = false;
            } else {
                if (this.$store.getters.isLoggedIn) {
                    if (ideaValue.multiple) {
                        this.LocalVote[indice].id = ideaValue.id
                        this.LocalVote[indice].voteValue[voteValue] = true;
                    } else {
                        this.LocalVote[indice].voteValue = [false, false, false, false, false]
                        this.LocalVote[indice].id = ideaValue.id
                        this.LocalVote[indice].voteValue[voteValue] = true;
                    }
                } else {
                    this.$toastr('warning', 'Debes acceder con una cuenta para poder votar, si no tienes una puedes crearla', 'No has iniciado sesión');
                }


            }
            this.forceRerender();
        },
        /**
         * @param {number} ideaObject devuelve el id de la idea (0,1,2,3,4)
        */
        addOrEditVote(ideaObject) {
            this.currentMoment = this.$moment().local();
            this.setIsAvailableVoting();
            var self = this;
            const voteObject = this.LocalVote.find(vote => vote.id === ideaObject.id) || { voteValue: [false, false, false, false, false] };
            let hasVotes = voteObject.voteValue.reduce((acc, item) => {
                if (item === true) {
                    acc++
                }
                return acc;
            }, 0) > 0;


            if (voteObject && hasVotes) {
                if (ideaObject.multiple) {
                    let voteIndexes = voteObject.voteValue.reduce((array, item, index) => {
                        if (item === true) {
                            array.push(index)
                        }
                        return array
                    }, [])

                    voteIndexes.forEach(voteID => {
                        postVote(voteID)
                    })
                }
                else {
                    let voteIndex = voteObject.voteValue.indexOf(voteObject.voteValue.find(value => value === true));
                    postVote(voteIndex)
                }
            }
            else {
                self.$toastr('error', 'No has seleccionado un voto', 'Error');
            }

            function postVote(voteIndex) {
                axios
                    .post('/ideas/' + ideaObject.id + '/voteConsultation', {
                        vote: voteIndex
                    })
                    .then(res => {
                        const vote = res.data.data;
                        self.votes.push(vote)
                        if (voteIndex === 0) {
                            ideaObject.votes_0 += 1;
                            ideaObject.userVoted[0] = true;
                            console.log(ideaObject.userVoted[0]);
                        } else if (voteIndex === 1) {
                            ideaObject.votes_1 += 1;
                            ideaObject.userVoted[1] = true;
                        } else if (voteIndex === 2) {
                            ideaObject.votes_2 += 1;
                            ideaObject.userVoted[2] = true;
                        } else if (voteIndex === 3) {
                            ideaObject.votes_3 += 1;
                            ideaObject.userVoted[3] = true;
                        } else if (voteIndex === 4) {
                            ideaObject.votes_4 += 1;
                            ideaObject.userVoted[4] = true;
                        }
                        if (vote.gamification_result && vote.gamification_result.rewards.length > 0) {
                            self.$store.dispatch('hasNewNotifications', true);
                            self.$toastr('success', this.$t('navbar.notificaciones.mensajes.nuevas_recompensas.cuerpo'), self.$t('navbar.notificaciones.mensajes.nuevas_recompensas.titulo'));
                        }
                        self.forceRerender();
                        self.$emit('updateStackedChartVotos', vote.id);
                        self.$toastr('success', 'Tu voto fue registrado con éxito', 'Voto guardado');
                    })
                    .catch(() => {
                        self.$toastr('error', 'No se ha podido registrar tu voto', 'Error');
                    });
            }
        },
        forceRerender() {
            this.keyChartComponent += 1
            this.$forceUpdate();
        }
    },
}
</script>
<style lang="scss">
.tooltip {
    display: block !important;
    z-index: 10000;
    background: none !important;
}

.tooltip .tooltip-inner {
    background: #232729;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
    width: 1;
    height: 2px;
    border-style: solid;
    position: absolute;
    // margin: 5px;
    border-color: #232729;
}

.tooltip[x-placement^="top"] {
    margin-bottom: 10px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: 0px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
}
</style>